module.exports = __webpack_public_path__ + "static/scale-model-of-davie-florida-afd78a8bc919900e917ea5548a47adfc.png";